import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { mediaUrl } from "@/lib/api";
import { useCurrency } from "@/context/CurrencyContext";

export const YouMightLike = ({ currentSlug }) => {
  const { format } = useCurrency();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/crafts")
      .then((r) => setItems((r.data || []).filter((c) => c.slug !== currentSlug).slice(0, 3)))
      .catch(() => {});
  }, [currentSlug]);

  if (!items.length) return null;

  return (
    <section data-testid="you-might-like" className="border-t border-cream/12 bg-cocoa/30">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <p className="text-[0.62rem] tracking-[0.3em] uppercase text-gold text-center mb-2">More from the studio</p>
        <h2 className="font-serif text-2xl sm:text-3xl text-center mb-10">You might also like</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((c) => (
            <Link key={c.id} to={`/crafts/${c.slug}`} data-testid={`suggest-${c.slug}`}
              className="group block border border-cream/12 hover:border-gold/40 transition-colors">
              <div className="aspect-[4/5] bg-espresso/40 overflow-hidden">
                {c.cover_image ? (
                  <img src={mediaUrl(c.cover_image)} alt={c.title}
                    className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700" />
                ) : null}
              </div>
              <div className="p-4">
                <p className="font-serif text-lg text-cream group-hover:text-gold transition-colors">{c.title}</p>
                {c.subtitle && <p className="text-cream/50 text-xs mt-1 truncate">{c.subtitle}</p>}
                <p className="text-gold text-sm mt-2 tabular-nums">{format(c.price)}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default YouMightLike;
